export const environment = {
  firebase: {
    // Prod firebase
    apiKey: "AIzaSyAxMSx6A89OE5VF5wYcgQKVRdtRem9JWpI",
    authDomain: "iflex-thailand.solvay.com",
    projectId: "solvay-iflexi-thailand-prod",
    storageBucket: "solvay-iflexi-thailand-prod.appspot.com",
    messagingSenderId: "193825575709",
    apiURL: "https://iflex-thailand-api.solvay.com/api/",
    nonApiURL: "https://iflex-thailand-api.solvay.com/"

  },
  production: true
};
